import { IconButton, InputAdornment, TextField } from "@mui/material";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { UserInputContainer } from "./incidentSummary.styled";
import { styled } from "styled-components";
import { fontSize } from "styled-system";


interface UserInputProps {
    userPrompt: string;
    setUserPrompt: (prompt :string) => void;
    theme: any;
}

const StyledTextField = styled(TextField)`
  .MuiInputLabel-root: {
    fontSize: 1em;
  }

  box-shadow: inset 1.1px 1px 3.2px hsl(0deg 0% 0% / 0.47)
`

export function UserInput({theme, userPrompt, setUserPrompt}: UserInputProps) {
    /**
     * Send the user prompt and return a response (async as sendPrompt() has a Promise)
     * Set the initial and return in the Redux Messages slice as the in focus messages
     * The useEffect below will handle updating the conversations list with this new data
     */
    const sendPromptToApi = async () => {
      // Only submit a prompt if there is actually something to send
      if (userPrompt !== "") {
    
        // Clear the input box
        setUserPrompt("");
      }
    };
  
    /**
     * Handle alt-enter or clicking the send button.
     * @param event Event
     */
    const handleChange = (event) => {
      const value = event.target.value;
      setUserPrompt(value);
    };
  
    /**
     * Handle meta key and meta-enter key press.
     * @param event Event
     */
    const handleKeyPress = (event) => {
      if (event.code === "Enter" && event.shiftKey) return;
    
      if (event.code === "Enter") {
        event.preventDefault();
    
        // Let only non-empty text go through
        if (userPrompt.trim() !== "") {
          sendPromptToApi(); // This will only send text
        }
      }
    };
    
    return (
      <UserInputContainer>
        <div className="w-100">
          <span style={{display: 'flex', alignItems: 'center', flexDirection: 'column', opacity: "0.5"}}>
            <StyledTextField
              disabled={true}
              fullWidth
              multiline
              label="Enter your message here"
              value={userPrompt}
              onChange={handleChange}
              onKeyDown={handleKeyPress}
              sx={{backgroundColor: theme.colors.darkBlueBtn}}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="send prompt"
                      onClick={sendPromptToApi}
                      edge="end"
                    >
                      <SendOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </span>
        </div>
      </UserInputContainer>
    );
  }